import { render, staticRenderFns } from "./UsersNew.vue?vue&type=template&id=28b617e6&"
import script from "./UsersNew.vue?vue&type=script&lang=ts&"
export * from "./UsersNew.vue?vue&type=script&lang=ts&"
import style0 from "./UsersNew.vue?vue&type=style&index=0&id=28b617e6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports